module.exports = __webpack_public_path__ + "img/service2.4bf124cf.png";